import React, { createContext, useEffect, useState } from 'react';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Check localStorage first, fallback to sessionStorage
    const [token, setToken] = useState(
        localStorage.getItem('token') || sessionStorage.getItem('token') || ''
    );

    // const backendUrl =  ;

    // Fetch user info on token change
    useEffect(() => {
        if (!token) {
            setLoading(false);
            setUser(null);
            return;
        }

        setLoading(true);
        fetch(`${process.env.REACT_APP_BACKEND_URL}/v1/user/check`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.user) {
                    setUser(data.user);
                } else {
                    logout();
                }
                setLoading(false);
            })
            .catch(() => {
                logout();
                setLoading(false);
            });
    }, [token, process.env.REACT_APP_BACKEND_URL]);

    // Login function
    const login = async (email, password, rememberMe = false) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/v1/user/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });
            const data = await res.json();
            if (data.user && data.token) {
                setUser(data.user);
                setToken(data.token);
                // Save token according to rememberMe
                if (rememberMe) localStorage.setItem('token', data.token);
                else sessionStorage.setItem('token', data.token);
                return { success: true };
            } else {
                return { success: false, error: data.error || 'Login failed' };
            }
        } catch (err) {
            return { success: false, error: 'Login error' };
        }
    };

    // Signup function
    const signup = async (userData) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/v1/user/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(userData),
            });
            const data = await res.json();
            if (data.message === 'success') return { success: true };
            return { success: false, error: data.error || 'Registration failed' };
        } catch (err) {
            return { success: false, error: 'Registration error' };
        }
    };

    // Logout
    const logout = () => {
        setUser(null);
        setToken('');
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
    };

    return (
        <AuthContext.Provider
            value={{
                login,
                signup,
                logout,
                user,
                setUser,
                loading,
                // process.env.REACT_APP_BACKEND_URL,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
